import { GetContextMenuItemsParams, GetMainMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';

export interface IRouterNavigationConfig {
    base: string;
    idKey: string;
    extra?: string[];
}

export const getMenuItems = (
    params: GetMainMenuItemsParams | GetContextMenuItemsParams,
    excludeItems: (MenuItemDef | any)[]
): (MenuItemDef | any)[] => {
    const menuItems: (MenuItemDef | any)[] = params.defaultItems?.slice() ?? [];

    return menuItems.filter((item) => !excludeItems.includes(item));
};
